<template>
  <div id="china" class="pt" :class="{ h5: this.$store.state.webType === 'h5' }">
    <el-row :span="24" class="page-content">
      <div class="publish_events_box">
        <div class="publish_events_box_title">Publish News</div>
        <div class="publish_events_box_form">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="250px"
            class="demo-ruleForm"
          >
            <el-form-item label="Title:" prop="title">
              <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="Classification:" prop="label">
              <el-select v-model="ruleForm.label" placeholder="" style="width: 100%">
                <el-option label="WFUCA News" value="102"></el-option>
                <el-option label="Other News" value="103"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Country:" prop="country">
              <el-input v-model="ruleForm.country"></el-input>
            </el-form-item>
            <el-form-item label="Banner:" prop="coverImage">
              <image-upload :limit="1" v-model="ruleForm.coverImage" />
            </el-form-item>
            <!-- <el-form-item label="Banner:" prop="coverImg">
                 :action="this.$api + '/un/file/upload'"
              <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                drag
                multiple
                :file-list="uploadList"
                :http-request="uploadURL"
                :before-upload="handleBeforeUpload"
                :limit="1"
                :on-remove="handleRemove"
                ref="fileupload"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">590 × 310 px, .jpg .png, < 2M</div>
                <div class="el-upload__tip" slot="tip"></div>
              </el-upload>
            </el-form-item> -->
            <el-form-item label="Brief Introduction：" prop="brief">
              <el-input type="textarea" v-model="ruleForm.brief"></el-input>
            </el-form-item>
            <el-form-item label="News Description" prop="content">
              <tinymce
                :width="940"
                :height="300"
                v-model="ruleForm.content"
                ref="tinymce"
              ></tinymce>
            </el-form-item>
            <el-form-item>
              <el-button class="sub_btn_form" type="primary" @click="submitForm('ruleForm')"
                >Submit</el-button
              >
              <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import Tinymce from "@/components/tinymce";
import ImageUpload from "@/components/ImageUpload";
export default {
  name: "china",
  components: {
    Tinymce,
    ImageUpload,
  },
  data() {
    return {
      uploadList: [],
      gutterWidth: 20,
      ruleForm: {
        title: "",
        label: "",
        country: "",
        coverImage: "",
        brief: "",
        content: "",
        type: 1,
      },
      rules: {
        title: [{ required: true, message: "Please input Title", trigger: "blur" }],
        label: [{ required: true, message: "Please choose Classification", trigger: "change" }],
        country: [{ required: false, message: "Please input Country", trigger: "change" }],
        coverImage: [
          {
            required: true,
            message: "Please upload Banner",
            trigger: "blur",
          },
        ],
        brief: [
          {
            required: true,
            message: "Pleanse input Brief Introduction",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "Please input News Description:",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.query.token) {
      sessionStorage.setItem("token", this.$route.query.token);
    }
  },
  beforeUpdate() {
    // this.resetForm("ruleForm");
    // this.ruleForm = {};
    // this.uploadList = [];
  },
  methods: {
    editAticle(aId) {
      this.$get(this.$api + "/un/webarticle/getInfo?aId=" + aId).then((res) => {
        this.ruleForm = res.data;
      });
    },
    handleRemove: function (file, fileList) {
      this.uploadList = [];
    },
    submitForm(formName) {
      this.ruleForm.language = localStorage.getItem("lang");
      this.ruleForm.token = sessionStorage.getItem("tokenPub");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = "/un/webrelease/addarticle";
          if (this.ruleForm.aId) {
            //修改
            url = "/un/webrelease/edit";
          }
          this.$post(this.$api + url, this.ruleForm).then((res) => {
            this.$message({
              message:
                this.$store.state.lang == "FR" ? "Soumettre avec succès!" : "Submit Success！",
              type: "success",
            });
            this.resetForm("ruleForm");
            this.$emit("handleSubmitList", "news");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_btn_form {
  background-color: rgba(0, 93, 176, 1);
  border-radius: 35px;
  height: 49px;
  width: 307px;
}

.publish_events_box {
  margin: 0 auto;
  width: 100%;
  color: #333333;
  border-top: 1px solid #e4e4e4;
  .publish_events_box_title {
    font-size: fh(36vh, pc);
    line-height: fh(44vh, pc);
    font-weight: 500;

    white-space: nowrap;
    padding: fh(20vh, pc) 0;
  }
  ::v-deep .publish_events_box_form {
    padding-top: fh(40vh, pc);
    padding-bottom: fh(60vh, pc);
    .el-form-item__label {
      text-align: left;
    }
  }
}
</style>
